import { STATS } from "@/data/content";
import { Counter } from "@/components/site/Counter";
import { Reveal } from "@/components/site/Reveal";

export const Stats = () => (
  <section data-testid="stats-section" className="relative overflow-hidden bg-[#0E2657] py-24 sm:py-28 grain">
    <div className="grid-lines absolute inset-0 opacity-60" />
    <div className="container-x relative">
      <p className="eyebrow text-cyan-400">By the numbers*</p>
      <div className="mt-12 grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08} className="bg-[#0E2657] p-8 sm:p-10">
            <p className="font-display text-5xl font-bold tracking-tight text-white sm:text-6xl">
              <Counter value={s.value} suffix={s.suffix} decimals={s.decimals || 0} testId={`stat-value-${i}`} />
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-slate-300">
              <span className="h-1.5 w-1.5 rounded-full bg-cyan-400" /> {s.label}
            </p>
          </Reveal>
        ))}
      </div>
      <p className="mt-5 text-xs text-slate-400">*Placeholder figures — swap with your verified numbers.</p>
    </div>
  </section>
);
